import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '../';
import { OverviewStepHero } from '../OverviewStepHero';
import { OverviewStepContent } from '../OverviewStepContent';
import './OverviewStep.css';

export const OverviewStep = ({
  currentStep,
  currentOverviewSteps,
  handleNextStep,
  handleGoToAnswer,
  currentOnboardingSteps,
  onboardingFullSteps,
}) => {
  const overviewInfoIndex = currentOverviewSteps.findIndex(
    elem => elem.key === currentStep,
  );

  return (
    <Container>
      <OverviewStepHero overviewInfoIndex={overviewInfoIndex} />
      <OverviewStepContent
        isDashboard={false}
        currentStep={currentStep}
        handleGoToAnswer={handleGoToAnswer}
        currentOverviewSteps={currentOverviewSteps}
        handleNextStep={handleNextStep}
        currentOnboardingSteps={currentOnboardingSteps}
        onboardingFullSteps={onboardingFullSteps}
        overviewInfoIndex={overviewInfoIndex}
      />
    </Container>
  );
};

OverviewStep.propTypes = {
  currentStep: PropTypes.string,
  currentOverviewSteps: PropTypes.array,
  handleNextStep: PropTypes.func,
  handleGoToAnswer: PropTypes.func,
  currentOnboardingSteps: PropTypes.array,
  onboardingFullSteps: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/OverviewStep/OverviewStep.js